/**
 * Gangart des Spiels.
 *
 * Zwei Profile ("flink" und "gemessen") sind Faktoren auf dieselben Grundwerte.
 * Damit lässt sich vergleichen, wie sich das Spiel anfühlt, wenn man wirklich
 * geht und schwer zuschlägt — ohne dass jemand dreißig Zahlen von Hand dreht.
 *
 * Alle Systeme lesen die Faktoren hier, nirgends sonst.
 */

import type { Inhalte, TempoProfil } from '@pg/content';
import type { Welt } from './typen.js';

const NEUTRAL: TempoProfil = {
  name: 'Flink',
  beschreibung: '',
  spielerTempo: 1,
  gegnerTempo: 1,
  abklingen: 1,
  wirkdauer: 1,
  schaden: 1,
  angriffstakt: 1,
  aufhebeRadius: 1,
};

export function tempo(welt: Welt, inhalte: Inhalte): TempoProfil {
  return inhalte.regelwerk.tempoProfile.profile[welt.tempoprofil] ?? NEUTRAL;
}

export function tempoNamen(inhalte: Inhalte): string[] {
  return Object.keys(inhalte.regelwerk.tempoProfile.profile);
}
